{
    "CxiLicenceType_SOLO": "Solo",
    "CxiLicenceType_TEAMS": "Equipes",
    "CxiLicenceType_CXI": "Integração CX",
    "CxiLicenceType_NONE": "Nenhum",
    "NAME": "CxiLicenceTypes"
}